import { render, staticRenderFns } from "./FeatureCardSection.vue?vue&type=template&id=3cddad9b&"
import script from "./FeatureCardSection.vue?vue&type=script&lang=js&"
export * from "./FeatureCardSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCardSection});
